
module dg.objects {
   
    angular.module('dg.objects').component('colonLayout', {
        bindings: {
            propertyId: '@',
            options: '<?'
        },
        require: {
            ObjectDisplayerController: '^objectDisplayer'
        },
        controller: DisplayLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/colon-layout.html'
    });
}